export default "__VITE_ASSET__DFmZohaN__"